import React, { Fragment, useState } from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Collapse from "@mui/material/Collapse";
import { Link, useLocation } from "react-router-dom";
import './style.css';

const MobileMenu = () => {
    const location = useLocation();
    const [openId, setOpenId] = useState(0);
    const [menuActive, setMenuState] = useState(false);

    const isActive = (path) => location.pathname.startsWith(path);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
        setMenuState(false); // Close mobile menu after click
    }

    // Define menu items with submenus matching your Header component
    const menus = [
        {
            id: 1,
            title: 'Home',
            link: '/home',
            submenu: null
        },
        {
            id: 2,
            title: 'About',
            link: '/about',
            submenu: [
                {
                    id: 21,
                    title: 'Background',
                    link: '/about'
                },
                {
                    id: 22,
                    title: 'Career',
                    link: '/career'
                }
            ]
        },
        {
            id: 3,
            title: 'Services',
            link: '/service',
            submenu: [
                {
                    id: 31,
                    title: 'Study Abroad',
                    link: '/service/Study-Abroad'
                },
                {
                    id: 32,
                    title: 'Document Verification',
                    link: '/service/DocumentVerification'
                },
                {
                    id: 33,
                    title: 'Travels and Tour',
                    link: '/service/travels'
                },
                {
                    id: 34,
                    title: 'Workstation',
                    link: '/service/Workstation'
                }
            ]
        },
        {
            id: 4,
            title: 'Events',
            link: '/events',
            submenu: [
                {
                    id: 41,
                    title: '10th Anniversary',
                    link: '/events/10th-Anniversary'
                },
                {
                    id: 42,
                    title: 'Pre-Departure Event',
                    link: '/events/Pre-departure-Events'
                },
                {
                    id: 43,
                    title: 'Business Retreat',
                    link: '/events/Business-Retreat'
                },
                {
                    id: 44,
                    title: 'Education Fair',
                    link: '/events/Education-Fair'
                }
            ]
        },
        {
            id: 5,
            title: 'CSR',
            link: '/csr',
            submenu: [
                {
                    id: 51,
                    title: 'Research Grant',
                    link: '/csr/Research-Grant'
                },
                {
                    id: 52,
                    title: 'Charity',
                    link: '/csr/Charity'
                }
            ]
        },
        {
            id: 6,
            title: 'Blog',
            link: '/blog',
            submenu: null
        },
        {
            id: 7,
            title: 'Contact',
            link: '/contact',
            submenu: null
        }
    ];

    return (
        <div>
            <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
                <div className="menu-close">
                    <div className="clox" onClick={() => setMenuState(!menuActive)}>
                        <i className="ti-close"></i>
                    </div>
                </div>

                <ul className="responsivemenu">
                    {menus.map((item) => {
                        return (
                            <ListItem 
                                className={item.id === openId ? 'active' : null} 
                                key={item.id}
                            >
                                {item.submenu ? (
                                    <Fragment>
                                        <div 
                                            className="mobile-menu-item"
                                            onClick={() => setOpenId(item.id === openId ? 0 : item.id)}
                                        >
                                            <span className={isActive(item.link) ? "active-link" : ""}>
                                                {item.title}
                                            </span>
                                            <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                        </div>
                                        <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                            <List className="subMenu">
                                                {item.submenu.map((submenu) => {
                                                    return (
                                                        <ListItem key={submenu.id}>
                                                            <Link 
                                                                onClick={ClickHandler} 
                                                                className={isActive(submenu.link) ? "active-link" : ""}
                                                                to={submenu.link}
                                                            >
                                                                {submenu.title}
                                                            </Link>
                                                        </ListItem>
                                                    );
                                                })}
                                            </List>
                                        </Collapse>
                                    </Fragment>
                                ) : (
                                    <Link 
                                        onClick={ClickHandler} 
                                        className={isActive(item.link) ? "active-link" : ""}
                                        to={item.link}
                                    >
                                        {item.title}
                                    </Link>
                                )}
                            </ListItem>
                        );
                    })}
                </ul>

            </div>

            <div className="showmenu" onClick={() => setMenuState(!menuActive)}>
                <button type="button" className="navbar-toggler open-btn">
                    <span className="icon-bar first-angle"></span>
                    <span className="icon-bar middle-angle"></span>
                    <span className="icon-bar last-angle"></span>
                </button>
            </div>
        </div>
    );
};

export default MobileMenu;